/**
 * Semantyczny ton statusu — jeden słownik dla całej aplikacji.
 *
 * Statusy rat, wpłat, zgód i rezerwacji mówią to samo („poszło dobrze”,
 * „uwaga”, „źle”), więc i barwę biorą z jednego miejsca. Wcześniej ta sama
 * czwórka kolorów stała przepisana heksami w pięciu plikach.
 *
 * `caution` to stan pośredni między `warning` a `error` — coś się wydarzyło
 * i już nie da się tego cofnąć, ale nie jest to błąd.
 */
export type StatusTone =
  | 'neutral'
  | 'info'
  | 'success'
  | 'warning'
  | 'caution'
  | 'error';

export interface StatusToneColors {
  /** Tło odznaki. */
  bg: string;
  /** Kolor napisu i ikony. */
  text: string;
  /**
   * Kropka przy etykiecie w tabeli. Osobny odcień, bo `bg` to blada plama pod
   * napisem — ośmiopikselowe kółko w tym kolorze byłoby niewidoczne.
   */
  dot: string;
  /**
   * Stan wymagający reakcji. W tabeli etykieta idzie wtedy tonem i wytłuszczona
   * zamiast zwykłym tekstem — „Zaległe” ma się rzucać w oczy, „Opłacone” nie.
   */
  attention?: boolean;
}

export const STATUS_TONE_COLORS: Record<StatusTone, StatusToneColors> = {
  neutral: { bg: '#F0F0F5', text: '#5A5A72', dot: '#C4C4D4' },
  info: { bg: '#CFE8FC', text: '#0B6FC1', dot: '#0B6FC1' },
  success: { bg: '#DBF5D6', text: '#417D36', dot: '#77CC66' },
  warning: { bg: '#FCEFCF', text: '#995200', dot: '#F2AD0D' },
  caution: { bg: '#FFE8B2', text: '#995200', dot: '#F7BE6E', attention: true },
  error: { bg: '#F5D6D6', text: '#981B1B', dot: '#E05252', attention: true },
};
